import React, { useEffect, useRef } from 'react';
import whatGelDoImage from '../../assets/what-gel-do-image.png';
import { FaCheck } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';

const WhatGelDo = () => {

  const points = [
    "SVB registration, finalization (IR), and renewal",
    "Final assessment and bond closure",
    "Customs duty and IGST refunds",
    "Bonded and non-bonded warehouse solutions",
    "DGFT consultancy and import/export licensing",
    "Bureau of Indian Standards (BIS) compliance",
    "GST consultancy",
    "AEO consultancy",
    "Private bonded warehouse licensing",
    "Filing and processing of import/export applications with EOU, STPI, EHTP, and SEZ authorities."
  ];

    const location = useLocation();
    const scrollRef = useRef(null);
  
    useEffect(() => {
      if (location.state?.scrollTo === "what-gel-do" && scrollRef.current) {
        scrollRef.current.scrollIntoView({ behavior: "instant", block: "start" });
      }
    }, [location]);

  return (
    <div  ref={scrollRef} id="what-gel-do" className="w-full mb-12 md:py-12">
      {/* Heading */}
      <div className="text-center mb-4 md:mb-12">
        <h2 className="text-2xl md:text-4xl text-[#011B5D] font-bold">What Gel Do</h2>
        <div className="border-b-4 border-[#011B5D] w-32 md:w-48 mx-auto mt-1 md:mt-2"></div>
      </div>

      <div className="w-full px-4">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-4 md:gap-8 mx-4 md:mx-12">

          {/* Image for Small Screens */}
          <div className="w-full lg:hidden mb-4">
            <img 
              src={whatGelDoImage} 
              alt="What Gel Do" 
              className="w-full max-h-48 object-contain mx-auto"
            />
          </div>

          {/* Left side: Points List */}
          <div className="w-full lg:w-1/2 space-y-1 md:space-y-2 ml-2 md:ml-8">
            {points.map((point, index) => (
              <div key={index} className="flex items-start space-x-1 md:space-x-2">
                {/* Tick mark icon */}
                <div>
                  <FaCheck className="text-black mr-1 md:mr-3 ml-1 md:ml-2" /> 
                </div>
                {/* Point description */}
                <p className="text-sm md:text-lg leading-snug md:leading-normal">{point}</p>
              </div>
            ))}
          </div>

          {/* Right side: Image for Large Screens */}
          <div className="w-full hidden lg:block lg:w-1/2 lg:h-[400px]">
            <img 
              src={whatGelDoImage} 
              alt="What Gel Do" 
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatGelDo;
